﻿
import * as states from './stateAbbreviations/stateAbbreviations.constant';

export default angular.module('idi.marketplace.constants', [])
    .constant('stateAbbreviations', states.UsStatesService.states)
    .name;
